import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AddProductContainerCommand, DeActivateProductContainerCommand } from '@shared/models/commands';
import { ProductContainer } from '@shared/models';


export const ProductContainerActions = createActionGroup({
  source: 'ProductContainer',
  events: {
    'Reset': emptyProps(),

    'Add': props<{ command: AddProductContainerCommand }>(),
    'Add Success': props<{ productContainer: ProductContainer }>(),
    'Add Failure': props<{ error: any }>(),

    'DeActivate': props<{ command: DeActivateProductContainerCommand }>(),
    'DeActivate Success': props<{ productContainer: ProductContainer }>(),
    'DeActivate Failure': props<{ error: any }>(),

    'Update': props<{ deactivateCommand: DeActivateProductContainerCommand; addCommand: AddProductContainerCommand }>(),
    'Update Success': props<{ productContainer: ProductContainer }>(),
    'Update Failure': props<{ error: any }>(),

    'Load': emptyProps(),
    'Load Success': props<{ productContainers: ProductContainer[] }>(),
    'Load Failure': props<{ error: any }>(),
  },
});